import { useDispatch } from 'react-redux';
import { useViewedVehicle } from './useViewedVehicle';
import { useEffect } from 'react';
import { setImages } from 'services/viewVehicleSlice/viewVehicleSlice';
import { useExteriorSectionData } from '../components/VehicleSections/hooks/useExteriorSection';
import { useLevel1SectionData } from '../components/VehicleSections/hooks/useLevel1Section';
import { useDashImages } from '../components/VehicleSections/hooks/useDashImages';
import { useOBDImages } from '../components/VehicleSections/hooks/useOBDImages';
import { useTireImages } from '../components/VehicleSections/hooks/useTireImages';

export const useInitImages = () => {
  const dispatch = useDispatch();

  const { images: exteriorImages } = useExteriorSectionData('exterior');
  const { images: fitFinishFrameImages } = useExteriorSectionData('fit_finish_frame');
  const { images: interiorImages } = useLevel1SectionData('interior_questions');
  const { images: underHoodImages } = useLevel1SectionData('under_hood');
  const tiresImages = useTireImages();
  const obdImages = useOBDImages();
  const dashImages = useDashImages();

  useEffect(() => {
    const combined = [
      exteriorImages,
      tiresImages,
      fitFinishFrameImages,
      interiorImages.slice(1),
      underHoodImages,
      obdImages,
      dashImages
    ]
      .flat()
      .filter(img => !!img.url);
    dispatch(setImages(combined));
  }, [exteriorImages, tiresImages, fitFinishFrameImages, interiorImages, underHoodImages, obdImages, dashImages]);
};
